module.exports = __webpack_public_path__ + "img/Lupus.a23fbb88.png";